import { isFunction } from 'lodash';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import IconMapping from '@components/iconMapping.js';

export default {
  props:{
    component: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    isSelectedComponent: {
      type: Boolean,
      default: false
    },
    disableToolbarButtons: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const {type} = this.component;
    const dbentry = ComponentsDb.findDbEntry(this.component);
    let dataSchema = dbentry.dataSchema;
    if (isFunction(dataSchema)) {
      dataSchema = dataSchema({component:this.component});
    }
    const icon = IconMapping[type];

    return {
      dbentry,
      icon,
      dataSchema
    }
  },
  watch:{
    component: {
      handler() {
        let dataSchema = this.dbentry.dataSchema;
        if (isFunction(dataSchema)) {
          this.dataSchema = dataSchema({component:this.component});
        }
      },
      deep:true
    }
  }
}
